import useToast from "./useToast";
import { IErrorResponse } from "../../../services/HttpService";
import { useTranslation } from "react-i18next";
import { ITranslationFields } from "../../../locale/dictionary";

const errorTranslationMap = {
  400: "responseError400",
  401: "responseError401",
  402: "responseError402",
  403: "responseError403",
  404: "responseError404",
};

const useResponseErrorHandler = () => {
  const toast = useToast();
  const { t } = useTranslation();

  const responseStatusTranslation = (status: number): ITranslationFields => {
    return t(errorTranslationMap[status] || "responseErrorRequestFailed");
  };

  const responseErrorTranslation = (
    res: IErrorResponse
  ): ITranslationFields => {
    if (!res) return "responseErrorRequestFailed";

    if (res.data && res.localizationKey) {
      return res.localizationKey;
    }

    return responseStatusTranslation(res.status);
  };

  const responseErrorHandler = (error: IErrorResponse) => {
    if (error.localizationKey) {
      toast.error(t(error.localizationKey));
    } else if (error.data.message) {
      toast.error(error.data.message);
    } else if (error.status) {
      toast.error(responseStatusTranslation(error.status));
    }
  };

  return {
    responseErrorHandler,
    responseErrorTranslation,
    responseStatusTranslation,
  };
};

export default useResponseErrorHandler;
